export const RequestType = Object.freeze({
  PHONE_VERIFICATION: "PHONE_VERIFICATION",
  EMAIL_VERIFICATION: "EMAIL_VERIFICATION",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  F2F_PAYMENT: "F2F_PAYMENT"
});
